import {Component, Injector, Renderer2, ElementRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {preloadImageURL} from '../../../common/util/file-util';
import {PublicApiService} from '../../services/public-api.service';
import {LoadedRouteParam} from '../../../common/util/loaded-route-param';
import {PublicApiBadgeClassWithIssuer, PublicApiBadgeJobInsights, PublicApiIssuer, } from '../../models/public-api.model';
import {EmbedService} from '../../../common/services/embed.service';
import {addQueryParamsToUrl, stripQueryParamsFromUrl} from '../../../common/util/url-util';
import {routerLinkForUrl} from '../public/public.component';
import {AppConfigService} from '../../../common/app-config.service';
import {Title} from '@angular/platform-browser';

@Component({
	templateUrl: './badge-job-insights.component.html'
})
export class PublicBadgeJobInsightsComponent {
	readonly issuerImagePlaceholderUrl = preloadImageURL(
		require('../../../../breakdown/static/images/placeholderavatar-issuer.svg') as string
	);
	readonly badgeLoadingImageUrl = require('../../../../breakdown/static/images/badge-loading.svg') as string;
	readonly badgeFailedImageUrl = require('../../../../breakdown/static/images/badge-failed.svg') as string;
	readonly verifiedSrc = require('../../../../breakdown/static/images/dbadge-verified-200x68.png') as string;
	
	badgeIdParam: LoadedRouteParam<PublicApiBadgeClassWithIssuer>;
	jobInsights: PublicApiBadgeJobInsights;
	jobInsightsLoaded: Promise<unknown>;
	routerLinkForUrl = routerLinkForUrl;
	hasSearchError: boolean = false;
	resultsLoaded: boolean = false;
	keyword = 'name';
	badgeId = '';
	jobSearchKeywords = '';
	location = '';
	data = [];
   

	constructor(
		protected publicApiService: PublicApiService,
		private injector: Injector,
		public embedService: EmbedService,
		public configService: AppConfigService,
		private title: Title,
		private renderer:Renderer2,
		private elem: ElementRef
	) {
		title.setTitle(`Badge Class - ${this.configService.theme['serviceName'] || "Badgr"}`);
		
		this.badgeIdParam = new LoadedRouteParam(
			injector.get(ActivatedRoute),
			"badgeId",
			paramValue => {
				const service: PublicApiService = injector.get(PublicApiService);
				return service.getBadgeClass(paramValue);
			}
		);


		let location;
		this.request('get','https://ipinfo.io/json').then((response: any) => {
			// location = JSON.parse(response.srcElement.response).city
			let ipLocation = JSON.parse(response.srcElement.response)
			location = ipLocation.city
			this.location = location

			const route = injector.get(ActivatedRoute)
			const badgeId = route.snapshot.paramMap.get('badgeId');
			this.badgeId = route.snapshot.paramMap.get('badgeId');
			
			let elements = this.elem.nativeElement.querySelectorAll('.tag');
			if(elements.length > 0){
				this.renderer.addClass(elements[0],'tag-selected');
			}

			this.jobInsightsLoaded = this.publicApiService.getBadgeJobInsights(badgeId, null, location).then(
				(jobInsights) => {
					this.resultsLoaded = true;
					this.jobInsights = jobInsights;
					let elements = this.elem.nativeElement.querySelectorAll('.tag');
					if(elements.length > 0){
						this.renderer.addClass(elements[0],'tag-selected');
					}

					if ('error' in jobInsights){
						this.hasSearchError = true;
						return;
					} 
					this.jobInsights = jobInsights;
				}
			)
		})
	}

	toggleJobTag(event: any, jobSearchKeywords: string) {

		this.hasSearchError = false;
		let elements = this.elem.nativeElement.querySelectorAll('.tag-selected');
		if(elements.length > 0){
			elements.forEach(element => {
				this.renderer.removeClass(element,'tag-selected');
			});
		}
		this.renderer.addClass(event.target,'tag-selected');

		this.searchJobInsights(jobSearchKeywords)
	}

	selectEvent(location) {
		this.hasSearchError = false;
		this.searchJobInsights(null, location.name)
	  }
	 
	onChangeSearch(location: string) {
		this.publicApiService.jobInsightsLocationSearch(location).then((locations: any) => {
			this.data = locations
		})
	}
	
	onFocused(e){
	// do something when input is focused
	}
	
	get badgeClass(): PublicApiBadgeClassWithIssuer { 
		return this.badgeIdParam.value;
	 }

	get issuer(): PublicApiIssuer {
		return this.badgeClass.issuer;
	}

	private get rawJsonUrl() {
		return stripQueryParamsFromUrl(this.badgeClass.id) + ".json";
	}

	private searchJobInsights(jobSearchKeywords: string = null, location: string = null){

		this.resultsLoaded = false;

		if(jobSearchKeywords !== null) this.jobSearchKeywords = jobSearchKeywords;

		if(location !== null) this.location = location;

		this.jobSearchKeywords = jobSearchKeywords;
		this.jobInsightsLoaded = this.publicApiService.getBadgeJobInsights(this.badgeId, this.jobSearchKeywords, this.location).then(
            (jobInsights) => {
				this.resultsLoaded = true;
				if ('error' in jobInsights){
					this.hasSearchError = true;
					return;
				} 
				this.jobInsights = jobInsights;
            }
        )
	}

	private  request(method, url) {
		return new Promise(function (resolve, reject) {
			var xhr = new XMLHttpRequest();
			xhr.open(method, url);
			xhr.onload = resolve;
			xhr.onerror = reject;
			xhr.send();
		});
	}

}
